import { DiagramDecisionGate } from "@/app/features/diagrams/components/shared/DiagramDecisionGate";
import { DiagramNode } from "@/app/features/diagrams/components/shared/DiagramNode";

export function WorkManagementNodes() {
  return (
    <g data-layer="nodes">
      <g>
        <rect
          x={30}
          y={48}
          width={180}
          height={450}
          rx={8}
          fill="none"
          stroke="var(--ga-line)"
          strokeDasharray="4 3"
        />
        <text
          x={40}
          y={68}
          fill="var(--ga-text-muted)"
          className="font-mono text-[11px] font-bold"
        >
          TASK QUEUE
        </text>
        <DiagramNode
          x={40}
          y={84}
          width={160}
          height={56}
          label="TASK A: READY"
          sublabel="Dependencies resolved"
          variant="brass"
        />
        <DiagramNode
          x={40}
          y={202}
          width={160}
          height={56}
          label="TASK B: READY"
          sublabel="Dependencies resolved"
          variant="brass"
        />
        <DiagramNode
          x={40}
          y={324}
          width={160}
          height={56}
          label="TASK C: DRAFT"
          sublabel="Scope being defined"
        />
        <DiagramNode
          x={40}
          y={430}
          width={160}
          height={56}
          label="CANCELLED"
          sublabel="Reason recorded"
          variant="fallback"
        />
      </g>
      <g>
        <rect
          x={330}
          y={48}
          width={240}
          height={450}
          rx={8}
          fill="none"
          stroke="var(--ga-line)"
          strokeDasharray="4 3"
        />
        <text
          x={340}
          y={68}
          fill="var(--ga-text-muted)"
          className="font-mono text-[11px] font-bold"
        >
          OWNERS & ACTIVE WORK
        </text>
        <DiagramNode
          x={340}
          y={84}
          width={220}
          height={56}
          label="WORKING: TASK A"
          sublabel="Owner 1 • Revision 4"
        />
        <DiagramNode
          x={340}
          y={202}
          width={220}
          height={56}
          label="WORKING: TASK B"
          sublabel="Owner 2 • Revision 2"
        />
        <DiagramNode
          x={340}
          y={324}
          width={220}
          height={56}
          label="HOLD / WAIT: TASK B"
          sublabel="Reason • Owner • Resume condition"
          variant="fallback"
        />
        <DiagramNode
          x={340}
          y={430}
          width={220}
          height={56}
          label="SHARED TASK RULES"
          sublabel="One owner • Revision checks"
          variant="brass"
        />
      </g>
      <g>
        <rect
          x={690}
          y={48}
          width={140}
          height={450}
          rx={8}
          fill="none"
          stroke="var(--ga-line)"
          strokeDasharray="4 3"
        />
        <text
          x={700}
          y={68}
          fill="var(--ga-text-muted)"
          className="font-mono text-[11px] font-bold"
        >
          COMPLETION
        </text>
        <DiagramNode
          x={700}
          y={84}
          width={120}
          height={56}
          label="VERIFY: TASK A"
          sublabel="Human or AI review"
        />
        <DiagramDecisionGate x={722} y={210} label="Pass?" />
        <DiagramNode
          x={714}
          y={338}
          width={92}
          height={92}
          label="CLOSED"
          sublabel="Accepted"
          shape="double-circle"
          variant="success"
        />
      </g>
    </g>
  );
}
